import React from "react";

import "./animatedCheckIcon.css";
import CheckIcon from "./checkIcon";

export default function AnimatedCheckIcon() {

    return <svg className="animated-check" viewBox="1.5 1.5 20 20">
        <path stroke="currentColor" d="M4 12L9 17.6 20.3 6.3" fill="none" /> </svg>;

}